module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch04"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("11:00")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Anna is fingering Lou’s card, absently using the edges to clean beneath her nails, when the train halts at a signal just before its final stop. To her left the city sprawls up and over the Downs, row upon row of terraced houses getting smaller into the distance. The sign at the end of the carriage is scrolling in orange dots: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The next station is Brighton")]), _vm._v(". Although she is nearly there, she feels completely disoriented, emotions all over the place. She has travelled from Brighton to Wivelsfield to Clapham up the motorway and back, and it’s only eleven. She feels as if she has left pieces of her mind scattered along the way and is no longer herself as a result.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She attempts to reassemble her thoughts into a more coherent stream, so as to help Karen. But how are they ever going to get through this? There’s the issue of Luke and Molly: how does one tell two small children their father has died? It is not just a question of telling them; it is how it will impact on their lives. What will this do to them, losing their father? They are so young; they have so much of their childhood to go. Then there is the rest of Simon’s family – his mother is still alive, for instance, and he has a brother too, Alan. Anna has met him many times, and he and Simon are close. He lives nearby and they play football together, down on the lawns on the seafront, with some other local dads.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And there is Karen herself. She and Simon have been together since Karen’s first job after college. Simon was living with another woman when they met – what a drama that caused. But that was aeons ago; they’ve been together for nearly twenty years. And while they have had a few bleak periods – there was the time when Simon lost his job, for example, and when Luke was very ill just after he was born – these ultimately didn’t threaten them as a couple. In fact, nothing has ever truly rocked their relationship…until today.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna shivers. She is aware this is just the beginning, the very beginning; and already she feels so much of Karen’s pain that she’s not sure where her own feelings end and Karen’s start. She is sure it hasn’t sunk in fully yet, because she still can’t believe what’s happened, that Simon is really gone. And although she shed a few tears an hour or so ago, it feels too soon to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe he isn’t dead, she allows herself to think, just for a split second. Maybe Karen has gone mad, got it wrong, or someone else has.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna shakes her head, suddenly angry. Of course no one’s got it wrong. But couldn’t someone, somewhere, have done more for him? A fifty-one-year-old man doesn’t just keel over: there had to be some signs, surely? Didn’t Simon himself know something was up? What about when he was playing football? Didn’t he feel a twinge, or anything, then? Why didn’t he have a check-up, get himself examined? He was a father, for heaven’s sake, with responsibilities. Failing that, the medical profession should have pre-empted it. Why didn’t his GP warn him? (Though she can’t imagine that Simon would readily go to the doctor; lots of men don’t. Anna’s own partner, Steve, hasn’t been to a doctor in years.) But what about those nurses Karen mentioned, on the train – why couldn’t they do anything? Or the bloody paramedics, or the doctors in Brighton’s precious cardiac ward? Doubtless it was because they were understaffed and unequipped. It was the government’s fault, then, too. Bunch of idiots. Fuck the lot of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then, another thought, less enraging, but more distressing. Anna is sure Karen will blame herself – it would be typical of her to do so. Karen can be a worrier, and always puts other people first. The children, Simon, often Anna too. And of course it’s not her fault, but Anna is sure she will think it is, will believe she has failed Simon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This leads Anna to touch, for the first time, on her own guilt. Perhaps "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" is the one who’s failed Simon. Karen not spotting his condition is understandable when she lived with him, and when she looks after so many people. Anna can comprehend how she could easily miss a gradual change in his health. But she, Anna, had the benefit of more objectivity. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" should have noticed something. Been less wrapped up in her work and the demands of her own relationship. She had seen Simon pretty much every week, hadn’t she, for God knows how long? She should have noticed that he was breathless, faint or dizzy, or had indigestion more than was normal, or was really pink in the face, or whatever symptoms there are that act as a forewarning to a heart attack, if she had been less self-absorbed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh dear, she thinks, coming back to the present with a jolt. The other passengers have gone ahead of her, and she is alone in her seat. She had better get off the train. The cleaner is making her way down the aisle, using gloved hands to put cups and discarded newspapers into a big clear plastic bag. So Anna pulls on her coat, picks up her handbag from the table and, for the second time that day, makes her way through Brighton station.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Karen is sitting in the cafe opposite the hospital, watching the clock on the wall. Only a few more minutes until Anna arrives. She wants to wait for her, she needs her help, guidance, before going back. Karen has never in her life needed rescuing, not from anything serious; she has always been the one to take care of others. Even when she was a little girl, she was the elder sister or bossy friend taking charge. But today has made up for forty years with one catastrophic event. She seems caught in a nightmare she cannot escape; she wants someone to wake her up, tell her it is all a mistake, it is not happening, she can go home. She feels completely disconnected from the world about her. The room she is sitting in looks unreal, the proportions all wrong for a cafe: it is too big, there is too much space between the tables, the strip fluorescent lights are eerily bright, the counter from which she collected her tea looks oddly one-dimensional, flat. And though she can hear voices – the cafe is sadly empty but still there are people, an elderly couple, for instance, and a woman cooing at her baby nearby – they sound distant, echoing, distorted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When she was an undergraduate, she dropped acid once, with Anna. She hated the experience; she felt so out of control. This is like that, but worse, because somehow even then, through her fear, she knew she was hallucinating, that it would end; that it was just a trick of the mind. Plus she’d had Anna with her, who was also tripping, but who had done it before and was rather enjoying it. She had helped ground Karen, talk her down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But here she is alone, and now she has no idea what to do. The person she would normally ask is Simon, so in her head she asks him, yet at the same time a voice in her head – the doctor’s from earlier – reminds her: he is dead. The two thoughts can’t co-exist: it is all very confusing. She can’t believe he has gone. She feels numbness, and suffused through the numbness, stabs of panic, like shards of glass. The panic is horrible, horrible – she feels she can’t control it; the numbness is better. It is the panic she wants to go away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Perhaps she should make a list. She is good at lists.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’s got all those legal papers in her bag; that’s good, she can write on the back of one of the sheets of A4. And yes, there’s a pen. She remembers putting it in the front pocket earlier; she’s been caught without a pen before on the train and it has irritated her. Though to feel mere irritation – she can’t imagine that will ever happen again. It was a lifetime ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, at an utter loss what else to do, she forces herself to draw upon her memories; she can use the experience they had with Simon’s father to help. Five years ago he’d died, also unexpectedly. He had an aneurysm and one day it popped. And if she’d told Simon to get himself checked out afterwards, in case it was heriditary, she had told him a dozen times, but did he? Of course not. Among the shards of glass comes a tidal wave of fury. She almost likes it though; it feels sort of normal. She has been cross with Simon before and she recognizes the sensation – this is the same, just more powerful, and she wants to scream. But in a split second it has gone, and she is back to the shards of glass, the numbness and panic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Simon’s dad died, she and Simon helped Simon’s mother to make a list of what to do. Karen puts all her focus into the task, and slowly, automatically, she begins to formulate the words.")]), _vm._v(" "), _c('div', {
    staticClass: "unOrderedList"
  }, [_c('p', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("1. Phone Tracy. Collect the children.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How odd, her writing looks pretty much the same as usual, slanting loops of black ink. She had expected it to look different.")]), _vm._v(" "), _c('div', {
    staticClass: "unOrderedList"
  }, [_c('p', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("2. Tell the children.")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She has no idea how she is going to do this, but before she has a chance to feel any pain she adds,")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bring them to the hospital to say goodbye?")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Next she puts:")]), _vm._v(" "), _c('div', {
    staticClass: "unOrderedList1"
  }, [_c('p', {
    staticClass: "listItem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("3. Go home. Phone:")])])]), _vm._v(" "), _c('ul', {
    staticClass: "bulletList1"
  }, [_c('li', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Simon’s Mum")])]), _vm._v(" "), _c('li', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Alan")])]), _vm._v(" "), _c('li', {
    staticClass: "listItem1",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Simon’s work")])])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh gosh, Simon’s work. She should phone them at once. They will have been expecting him. Lord, and the solicitor. They have missed the appointment. These people can’t wait until later, till she is home. They all need to know right now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She reaches for her phone again. The little stickers glitter and twinkle at her and she has a pang of affection for her daughter, Molly, who insisted on putting them there, so deliberately, in places that presumably mean something to Molly but appear random to anyone else. There is a star covering the circle of the logo, for instance, and tiny flowers round the screen. Karen starts to dial Simon’s work. But again she stops. She just can’t manage it. She can’t find it in herself to explain what has happened. Perhaps she can wait till Anna gets there. Anna can help. She puts the phone down, berating herself for not being able to cope. She always copes with everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Karen, hello.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looks up. Thank God, a familiar coat, bag, face: it is her friend.")]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "height": "46",
      "src": "Images/sp.jpg",
      "width": "103"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Before Anna does anything else, she steps forward and wraps her arms around her friend’s shoulders. Karen gets up and hugs Anna too, and they hold each other for a moment like that, in silence. Karen sits down again and Anna takes a seat opposite, but instantly feels too far away, so shifts the chair round and leans forward to take both her friend’s hands in hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She is struck by how Karen’s face has been transformed by the morning’s events. Usually her friend looks healthy and vibrant, but the flush in her cheeks has vanished. She looks wan, grey; her long hair, generally shiny as a conker, is soaking wet, drab; and her hazel eyes, which normally sparkle with warmth and feeling, are glazed, unseeing. The joy and energy have been replaced by fear and confusion. And it is not just her face that has changed – it is her whole body. It is as if she has literally been gutted, or had the wind sucked out of her by some giant vacuum cleaner. She is bowed, deflated. She is also shaking badly, her hands especially. Although – bless her – Karen has clearly been trying to write. Anna can see from the piece of paper opposite her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna wishes she could lift her up and take her back to her cosy living room, dry her off then ease her into her most comfortable armchair, wrap her in a blanket and light the fire. She would make her a hot chocolate and give her biscuits, too. Instead they are here – she glances around – in a place that would be bleak at the best of times, let alone on a rainy day in late February. It is utterly charmless; a big room lit by strip lights with ugly, battered metal furnishings, as far from consoling as a cafe can get.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m so sorry,’ she says, gently, and gives Karen a small, utterly half-hearted smile. She is sorry; she has probably never been as sorry about anything in her life. She can feel tears pricking, but she must not, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("must not")]), _vm._v(" cry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen shakes her head. ‘I don’t know what happened.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna exhales. ‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I think I’m in shock.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, sweetheart, I think we both are.’ She looks down at her friend’s hands in hers. We both have the faint beginnings of liver spots, Anna notices. We are getting old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Heart attack, they said.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Right.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen takes a deep breath. ‘I guess we could go now – I was waiting for you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where is he?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘This special room; they were sorting it out.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sure,’ nods Anna. She wonders if they are going to do a post-mortem. She thinks it will mean waiting longer for a funeral. But it also might provide some answers. She has many questions herself; doubtless Karen has more. Then again, maybe Karen won’t want one. It won’t bring Simon back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But before we go, I wondered; could you make a couple of calls for me?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course. Who to?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s just I really can’t face it.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna smiles sympathetically. ‘It’s OK – that’s fine. Who do you want me to ring?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The solicitors, if that’s all right. It’s just they were expecting us. And Simon’s work…’ She trails off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anna takes control. ‘No problem. Have you got the numbers?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes, here. Or it might be easier to ring on my phone, I guess.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sure.’ Anna picks up Karen’s mobile, with its familiar leather case and peeling stickers, from the table. ‘So, let’s ring the solicitors first.’ In one way she hates to be so down to earth and practical; in another it is a relief to be able to help with something relatively mundane. ‘Just tell me, had you exchanged on the house yet?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen shakes her head. ‘No…We were signing the papers today.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Phew, thinks Anna. This means there is room for manoeuvre. She switches into let’s-do-it mode. ‘Right. I’m going to ring the solicitors. Tell them you’re putting it on hold.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’ll be very cross,’ says Karen, suddenly engaging with other people’s reality.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I don’t give a bugger about that! And nor should you. Let’s not worry about that, shall we?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So, where’s the number?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The vendors will be upset too…’ adds Karen. It’s typical of her to be preoccupied with other people.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Never mind them either.’ Anna is brisk. ‘They can wait. At this moment we’re looking after you.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Karen nods.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Number…?’ she coaxes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Here you are.’ Karen, whose mind clicks back into gear with Anna to steer her, locates it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘OK,’ says Anna, getting to her feet. ‘But I’m going to do this outside, the signal in here is crap. You all right, waiting here for a bit?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Mm.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Anna pushes open the door of the cafe, the cold air and rain hit her. The signal is actually just as strong inside as it is out here; she has told a white lie. She thought it diplomatic Karen didn’t hear her go through the whole explanation of Simon’s death – it will only cause unnecessary pain. Given that it is sure to be the first call of many, it seems kind to soften the experience wherever and however she can.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4488bbb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429938327_ch04.vue
// module id = 78
// module chunks = 0